import { TTimeStamp } from '../@types';

export interface LoginFormData {
  email: string;
  password: string;
  sso_id: string;
}

export interface TwoFactorFormData {
  code: string;
  email?: string;
}

export enum TRole {
  STUDENT = 'student',
  TEACHER = 'teacher',
  MENTOR = 'mentor',
  ADMIN = 'admin',
}

export enum ModalType {
  NONE = 'none',
  COLLAB = 'collab',
  INVITE = 'invite',
  RENAME = 'rename',
  RESET = 'reset',
  ARCHIVE = 'archive',
  DELETE = 'delete',
  SKILLBUILDER = 'skillbuilder',
  STUDENT = 'Student',
}

export enum PopupType {
  ALLUSERS = 1,
  STUDENT = 2,
  TEACHER = 3,
}

export interface TSchool {
  alias: string;
  cbsa: string;
  cbsatype: number;
  cd: number;
  city: string;
  cnty: number;
  created_at: string;
  csa: string;
  id: string;
  lat: number;
  leaid: number;
  locale: number;
  lon: number;
  name: string;
  ncessch: number;
  necta: string;
  nmcbsa: string;
  nmcnty: string;
  nmcsa: string;
  nmnecta: string;
  opstfips: number;
  ppin: string;
  schoolyear: string;
  sldl: string;
  sldu: string;
  state: string;
  stfip: number;
  street: string;
  updated_at: string;
  zip: number;
}

export interface StudentInfo {
  guardian_name: string;
  guardian_email: string;
  teacher_name: string;
  teacher_email: string;
}

export interface TeacherOnboardingTaskCompletion {
  task_id: string;
  completed_at: string;
  user_id: string;
}

export default interface User extends TTimeStamp {
  first_name: string;
  last_name: string;
  user_name: string;
  email: string;
  id: string;
  role: TRole;
  organization: string;
  bio?: string;
  avatar?: TAvatar;
  full_name?: string;
  blocked_at?: string;
  state?: string;
  industry?: string;
  city?: string;
  naf_academy?: string | number | boolean;
  challenges?: Array<object>;
  school_id?: string;
  school?: TSchool;
  user_permissions?: any;
  userPopups?: Array<any>;
  student_info?: StudentInfo;
  referral_code?: string;
  teacher_onboarding_task_completions?: TeacherOnboardingTaskCompletion[];
  cant_find_school?: boolean;
  points?: number;
  guardian_name?: string;
  guardian_email?: string;
  teacher_name?: string;
  teacher_email?: string;
  skillbuilders?: string | string[];
  joined_challenges?: string | string[];
}

export interface GoogleSSO extends User {
  condition: string;
  google_object: object;
  responseCode?: string;
  message?: string;
  code?: number;
}

export interface TStudent extends User {
  city: string;
  state: string;
}

export type TTeacher = TStudent;

export interface TMentor extends User {
  industry: string;
}

export interface SignUpFormData {
  role: TRole;
  first_name: string;
  last_name: string;
  organization: string;
  industry: string;
  city: string;
  state: string;
  email: string;
  password: string;
  confirmPassword: string;
  mentorCode?: string;
  is_policy_accepted: boolean;
  is_role_accepted: boolean;
  sso_type: string;
  sso_id: string;
  naf_academy: string;
  sign_up_type: string;
  ageMonth?: number;
  ageDay?: number;
  ageYear?: number;
  school_id?: string;
  referralCode?: string;
}

export interface ForgotPasswordFormData {
  email: string;
}

export interface ResetPasswordFormData {
  email: string;
  password: string;
  password_confirmation: string;
  token: string;
}

export interface UpdatePasswordFormData {
  current_password: string;
  password: string;
  password_confirmation: string;
}

export interface DeleteAccountData {
  id: string;
}

export interface TAvatar {
  name: string;
  url: string;
}

export const AuthStateTypeMap = {
  SSO: 'sso',
  REDIRECTED: 'redirected',
  REDIRECT_LOAD: 'redirectLoad',
  GOOGLE_MODE: 'googleMode',
  GOOGLE_OBJECT: 'googleObject',
  PERSONAL_INFORMATION: 'personalInformation',
} as const;

export type AuthStateType = (typeof AuthStateTypeMap)[keyof typeof AuthStateTypeMap];
